import React, { Fragment, useState, useEffect, useRef} from "react";
import {  Form,  FormGroup,Row, Col,Button, Card, Label,Input, Container, Collapse } from "reactstrap";
import "../../style/styleeconfirm.css";


export default function PopUpEmployee(props) {
  // const {toggle}=props.toggle;
  const [open, setOpen] = useState('false');

  useEffect(() => {
    props.toggle ==true ? setOpen('true') : setOpen('false')
  }, [props.toggle]);

  return (
    <div className="popup-box">
      <div className="boxpopupall">
      <div className="d-inline float-right ">
                <Button color="" 
                onClick={(e) => props.handleClosePop(e)}
                >
                  <i className="fas fa-times text-muted"></i>
                </Button>
              </div>
              <br/>
<div className="topdiv">
  <h4 style={{marginLeft:"-160px"}}>Employee Creation Type</h4>
  {/* <div style={{marginLeft:"72px"}}>
  <i class="fa fa-exclamation fa-xl" style={{fontSize:"2.9em"}}></i><br/>
  </div> */}

<br/>
<div style={{marginLeft:"-42px"}}>
{/* <FormGroup check> */}
<table>
  <tr>
    <td>
    <Label check>
                  <Input type="radio" name="radio1" 
                  onClick={props.toogleFromEmployeeAddFormToExcel} 
                  /> Employee Add
                </Label>
    </td>
  </tr>
  <tr>
    <td>
    <Label check>
                  <Input type="radio" name="radio1"
                   onClick={props.toogleFromExcelToEmployeeAddForm}
                   /> Excel Import
                </Label>
    </td>
  </tr>
</table>
               
              {/* </FormGroup>
       <FormGroup check> */}
                
              {/* </FormGroup> */}
{/* <button className="btn-admin-settings btn btn-" onClick={props.hadleDelWithPopYes}>Yes</button>&nbsp;&nbsp;
<button className="btn-cancel btn btn-" onClick={props.hadleDelWithPopNo}>No</button> */}
</div>

      </div>
    </div>
</div>

  );
}
